export const START_AUTO_RENEW_START = 'START_AUTO_RENEW_START';
export const START_AUTO_RENEW_SUCCESS = 'START_AUTO_RENEW_SUCCESS';
export const START_AUTO_RENEW_ERROR = 'START_AUTO_RENEW_ERROR';
export const START_AUTO_RENEW_LOADING = 'START_AUTO_RENEW_LOADING';
export const START_AUTO_RENEW_CANCEL = 'START_AUTO_RENEW_CANCEL';

export type Actions = {
  START_AUTO_RENEW_START: { type: typeof START_AUTO_RENEW_START; payload: boolean };
  START_AUTO_RENEW_LOADING: { type: typeof START_AUTO_RENEW_LOADING; payload: boolean };
  START_AUTO_RENEW_SUCCESS: { type: typeof START_AUTO_RENEW_SUCCESS; payload: any };
  START_AUTO_RENEW_ERROR: { type: typeof START_AUTO_RENEW_ERROR; payload: any };
  START_AUTO_RENEW_CANCEL: { type: typeof START_AUTO_RENEW_CANCEL; payload: any };
};
// Action Creators
export const actionCreators = {
  startAutoRenewStart: (payload: any): Actions[typeof START_AUTO_RENEW_START] => ({
    type: START_AUTO_RENEW_START,
    payload,
  }),
  startAutoRenewError: (payload: any): Actions[typeof START_AUTO_RENEW_ERROR] => ({
    type: START_AUTO_RENEW_ERROR,
    payload,
  }),
  startAutoRenewSuccess: (payload: any): Actions[typeof START_AUTO_RENEW_SUCCESS] => {
    return ({ type: START_AUTO_RENEW_SUCCESS, payload: payload});
  },
  startAutoRenewLoading: (payload: boolean): Actions[typeof START_AUTO_RENEW_LOADING] => ({
    type: START_AUTO_RENEW_LOADING,
    payload,
  }),
  startAutoRenewCancel: (payload: boolean): Actions[typeof START_AUTO_RENEW_CANCEL] => ({
    type: START_AUTO_RENEW_CANCEL,
    payload,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/startautorenew/actions.ts